import {Poly} from '../../../@polygonjs/polygonjs/src/engine/Poly';
import {BaseNodeType} from '../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
import {NodesByRequestedName} from '../../engine/io/code/export/Nodes';

type NodesByRequestedNameFunc = () => NodesByRequestedName;

interface CoreClipboardRunOptions {
	printToConsole?: boolean;
}

export class CoreClipboard {
	static PARENT_NODE_VAR_NAME = 'parentNode';
	static run(parentNode: BaseNodeType, code: string, options?: CoreClipboardRunOptions) {
		parentNode.scene().cooker.block();

		//code = lodash_flatten(code_lines).join(";\n")
		const codeWrappedTimestamp = Math.floor(performance.now() * 10000);
		const codeWrappedFunctionName = `pasteClipboard${codeWrappedTimestamp}`;
		const codeWrapped = `var ${codeWrappedFunctionName} = function(${CoreClipboard.PARENT_NODE_VAR_NAME}){
		${code} };
		return ${codeWrappedFunctionName}(scene.node('${parentNode.path()}'));`;
		if (Poly.env() != 'test' && Poly.env() != 'development' && options?.printToConsole == true) {
			console.log('==================');
			console.log(codeWrapped);
			console.log('==================');
		}
		const codeWrappedFunction: NodesByRequestedNameFunc = new Function(codeWrapped) as NodesByRequestedNameFunc;
		const nodesByRequestedName = codeWrappedFunction();
		parentNode.scene().cooker.unblock();
		return nodesByRequestedName;
	}
}
